import { ROLES } from '../contexts/AuthContext';

// Default menu for standard companies (NJ Transit, Upwork, etc.)
const defaultMenuConfig = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'Dashboard',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: 'Folder',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
    children: [
      {
        id: 'projects-list',
        label: 'All Projects',
        icon: 'List',
        roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      },
      {
        id: 'projects-create',
        label: 'Create Project',
        icon: 'Add',
        roles: [ROLES.ADMIN, ROLES.MANAGER],
      },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: 'Description',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
    children: [
      {
        id: 'reports-weekly',
        label: 'Weekly Reports',
        icon: 'CalendarToday',
        roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      },
      // {
      //   id: 'reports-project',
      //   label: 'Project Report',
      //   icon: 'Assessment',
      //   roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      // },
      // {
      //   id: 'reports-history',
      //   label: 'Report History',
      //   icon: 'History',
      //   roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      // },
      {
        id: 'reports-weekly-history',
        label: 'Report History',
        icon: 'History',
        roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      },
      {
        id: 'reports-activity',
        label: 'Activity',
        icon: 'Timeline',
        roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      },
    ],
  },
  {
    id: 'users',
    label: 'Users',
    icon: 'People',
    roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN, ROLES.MANAGER],
    children: [
      {
        id: 'users-management',
        label: 'User Management',
        icon: 'Person',
        roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN, ROLES.MANAGER],
      },
      {
        id: 'users-permissions',
        label: 'Permissions',
        icon: 'Security',
        roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN, ROLES.MANAGER],
      },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN],
  },
  {
    id: 'logout',
    label: 'Logout',
    icon: 'Logout',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  },
];

// Real Estate menu for Century 21
const realEstateMenuConfig = [
  {
    id: 'real-estate-dashboard',
    label: 'Dashboard',
    icon: 'Dashboard',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 'properties-list',
    label: 'Properties',
    icon: 'Home',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 'buyers-list',
    label: 'Buyers',
    icon: 'People',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 're-reports',
    label: 'Reports',
    icon: 'Description',
    roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
    children: [
      {
        id: 're-reports-property',
        label: 'Property Status',
        icon: 'HomeWork',
        roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      },
      {
        id: 're-reports-buyer',
        label: 'Buyer Activity',
        icon: 'TrendingUp',
        roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
      },
    ],
  },
  {
    id: 'users',
    label: 'Users',
    icon: 'Group',
    roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN, ROLES.MANAGER],
    children: [
      {
        id: 'users-management',
        label: 'User Management',
        icon: 'Person',
        roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN, ROLES.MANAGER],
      },
      {
        id: 'users-permissions',
        label: 'Permissions',
        icon: 'Security',
        roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN, ROLES.MANAGER],
      },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    roles: [ROLES.ADMIN, ROLES.COMPANY_ADMIN],
  },
];

// Get menu config based on company ID
export const getMenuConfig = (companyId) => {
  if (companyId === 'century21') {
    return realEstateMenuConfig;
  }
  return defaultMenuConfig;
};

export default defaultMenuConfig;
